import { throttle } from 'throttle-debounce'
import { createTimeline } from '@/lib/timeline.js'
import Lenis from 'lenis'

export default (frames) => ({
    activeIndex: null,
    stickyTopOffset: 0,
    children: [],
    isMd: null,
    timelineMobile: null,
    timelineDesktop: null,

    init() {
        this.timelineMobile = createTimeline(
            frames.mobile,
            this.$refs.canvasMobile
        )
        this.timelineDesktop = createTimeline(
            frames.desktop,
            this.$refs.canvasDesktop
        )

        this.children = this.$refs.track.querySelectorAll('[data-index]')

        this.$nextTick(() => {
            this.onResize()
            this.onScroll()
        })

        window.addEventListener('resize', this.onResize.bind(this))

        const lenis = new Lenis({
            autoRaf: true,
            lerp: 0.05,
        })

        lenis.on('scroll', this.onScroll.bind(this))
    },

    calculateStickyOffset() {
        const isLg = window.matchMedia('(min-width: 1024px)').matches
        let offset = 0

        if (isLg) {
            offset =
                (this.$refs.container.offsetHeight - window.innerHeight) / -2
        } else {
            offset = Math.max(
                0,
                window.innerHeight / 2 - this.$refs.container.offsetHeight
            )
        }

        this.stickyTopOffset = offset
    },

    calculateBreakpoint() {
        this.isMd = window.matchMedia('(min-width: 769px)').matches
    },

    updateVideoCurrentTime() {
        const windowHeight = window.innerHeight
        const { top, height } = this.$el.getBoundingClientRect()
        const progress = Math.max(
            0,
            Math.min(1, (windowHeight - top) / (windowHeight + height))
        )

        if (this.isMd !== null) {
            if (this.isMd) {
                this.timelineDesktop.setProgress(progress)
            } else {
                this.timelineMobile.setProgress(progress)
            }
        }
    },

    calculateActiveIndex() {
        let activeIndex = null

        for (let i = 0; i < this.children.length; i++) {
            const { top, bottom } = this.children[i].getBoundingClientRect()

            if (top <= window.innerHeight && bottom >= window.innerHeight) {
                activeIndex = i

                break
            }
        }

        this.activeIndex = activeIndex
    },

    onResize: throttle(1000 / 60, function () {
        this.calculateBreakpoint()
        this.calculateStickyOffset()
    }),

    onScroll() {
        this.updateVideoCurrentTime()
        this.calculateActiveIndex()
    },

    goTo(index) {
        this.children[index]?.scrollIntoView({
            behavior: 'smooth',
        })
    },
})
